import React from 'react';
import MultiCarouselPlaceholderItem
    from 'components/box-product-carousel/components/multi-carousel-placeholder/multi-carousel-placeholder-item';

import './multi-carousel-placeholder.scss';

const MultiCarouselPlaceholder: React.FC<{itemCount: number;}> = ({ itemCount }) => (
    <div className="carousel-placeholder">
        {Array.from(Array(itemCount), (item, key) => <MultiCarouselPlaceholderItem key={key}/>)}
    </div>
);

export default MultiCarouselPlaceholder;
